import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelfServeGate } from 'hooks/billing/useSelfServeGate';
import { useUser } from 'hooks/useUser';
import { Loader } from 'components/Loader';
import { ROUTES } from '../consts';

export const PlansProtectedRoute = ({ children }: PropsWithChildren) => {
  const { isSelfServe, isLoading: selfServeLoading } = useSelfServeGate();
  const { isEnterpriseUser, isLoading: userLoading } = useUser();

  if (selfServeLoading || userLoading) {
    return <Loader center />;
  }

  if (isSelfServe || isEnterpriseUser) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return <>{children}</>;
};
